import * as React from 'react';
import { IconButton, Collapse } from '@material-ui/core';
import { ExpandLess } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { neutral } from '../../theme/colors';

interface Props {
  collapsed: boolean;
  onCollapse: (collapse: boolean) => void;
  title: string;
  /** Optional alternative component to wrap the element title, defaults to 'h2' */
  titleComponent?: React.ComponentType<any> | string;
  children: React.ReactNode;
  /** className passed to the component root section element */
  className?: string;
  secondaryAction?: React.ReactNode;
}

const useStyles = makeStyles({
  root: {
    marginTop: 20
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: 'transform 200ms'
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${neutral[500]}`
  },
  title: {
    color: neutral[600],
    fontSize: 16,
    fontWeight: 600,
    margin: '8px 0',
    lineHeight: '1em'
  },
  actionWrapper: {
    display: 'flex',
    alignItems: 'center'
  }
});

/**
 * Component which renders a generic collapsible section with a heading and expand button
 */
export function CollapsibleSection({
  title,
  titleComponent: TitleComponent = 'h2',
  collapsed,
  onCollapse,
  children,
  className,
  secondaryAction
}: Props) {
  const classes = useStyles();

  return (
    <section className={clsx(classes.root, className)}>
      <div className={classes.sectionHeader}>
        <div className={classes.actionWrapper}>
          <IconButton
            size="small"
            onClick={() => {
              onCollapse(!collapsed);
            }}
            className={clsx(classes.expand, !collapsed && classes.expandOpen)}
          >
            <ExpandLess />
          </IconButton>
          <TitleComponent className={classes.title}>{title}</TitleComponent>
        </div>
        {secondaryAction && <div className={classes.actionWrapper}>{secondaryAction}</div>}
      </div>
      <Collapse in={!collapsed}>{children}</Collapse>
    </section>
  );
}
